import {
  formatRdvDureeLabel,
  buildCommandeProductListCellDisplay,
  getCommandeProductLines,
  getMultiProductExtraCount,
  getPrestationAccentColor,
  resolveCommandeProductThumbUrl,
  resolvePrestationThumbUrl,
} from './mesCommandesMixedUx';

/**
 * Contexte ligne tableau Mes commandes (produit + RDV) — partagé commerçant / plateforme.
 */
export function buildMesCommandesRowContext(commande, deps) {
  const {
    isRendezVous,
    getStatusDisplay,
    getTypeBadge,
    getNextStatus,
    getRdvActions,
    updatingStatusId,
    getRdvTotalAmount,
    getCommandeFinancier,
    getListPrincipalAmount,
    formatEuro,
    getNextStatusLabel,
    getRdvConfirmationMeta,
    getRdvActionIcon,
  } = deps;

  const isRdv = isRendezVous(commande);
  const isPosComptoir = commande.canalVente === 'POS' && commande.modeRetrait === 'comptoir';
  const statusDisplay = getStatusDisplay(commande);
  const typeBadge = getTypeBadge(commande);
  const nextStatus =
    !isRdv && !isPosComptoir
      ? getNextStatus(commande.statut, commande.modeRetrait, commande)
      : null;
  const rdvActions = isRdv ? getRdvActions(commande.statut) : [];
  const isUpdating = updatingStatusId === commande.id;
  const totalBrut = isRdv ? getRdvTotalAmount(commande) : Number(commande.total ?? commande.prixFinal ?? 0);
  const finList = isRdv ? null : getCommandeFinancier(commande);
  const totalAmount = isRdv ? totalBrut : getListPrincipalAmount(commande);
  const dateValue = isRdv ? commande.dateDebut : commande.dateCommande;
  const dateText = dateValue
    ? new Date(dateValue).toLocaleString(
        'fr-FR',
        isRdv
          ? { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
          : { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' },
      )
    : '-';
  const firstLine = !isRdv ? getCommandeProductLines(commande)[0] : null;
  const firstProductName = firstLine?.produit?.nom || firstLine?.designationSnapshot || null;
  const productListCell = !isRdv ? buildCommandeProductListCellDisplay(commande) : null;
  const desc = commande.prestation?.description;
  const prestationSubtitle =
    isRdv && typeof desc === 'string' && desc.trim()
      ? desc.trim().slice(0, 48) + (desc.trim().length > 48 ? '…' : '')
      : null;

  return {
    isRdv,
    isPosComptoir,
    statusDisplay,
    typeBadge,
    nextStatus,
    rdvActions,
    isUpdating,
    totalBrut,
    finList,
    totalAmount,
    dateText,
    productImageUrl: !isRdv ? resolveCommandeProductThumbUrl(commande) : null,
    prestationImageUrl: isRdv ? resolvePrestationThumbUrl(commande) : null,
    extraProductCount: !isRdv ? getMultiProductExtraCount(commande) : 0,
    prestationAccent: isRdv ? getPrestationAccentColor(commande) : null,
    rdvDureeLabel: isRdv ? formatRdvDureeLabel(commande) : null,
    firstProductName,
    productListPrimaryText: productListCell?.primaryText ?? null,
    productListPreviewText: productListCell?.previewText ?? null,
    prestationSubtitle,
    formatEuro,
    getNextStatusLabel,
    getRdvConfirmationMeta,
    getRdvActionIcon,
  };
}
